import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-596fbaed"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 只能上传一个，MP3格式 ", -1))

import { ref, getCurrentInstance, computed, watch, reactive } from 'vue'
import type { UploadInstance, UploadProps, UploadRawFile, UploadUserFile } from 'element-plus'
import { getToken } from '@/utils/auth'

export default /*#__PURE__*/_defineComponent({
  __name: 'mp3-upload',
  props: {
    fileData: { default: [] }
  },
  emits: ['closed', 'confirm'],
  setup(__props: any, { emit }) {

const props = __props;

const { proxy } = getCurrentInstance()
const url = ref(process.env.VUE_APP_BASE_URL)
const headers = {
  Authorization: "Bearer " + getToken()
}
const fileList = ref([])
const upload = ref<UploadInstance>()
const progressValue = ref(0)
const progressFlag = ref(false)
const duration = computed(() => Math.floor(progressValue.value / 10))




watch(() => props.fileData, (newV) => {
  if (newV) {
    fileList.value = newV
  }

}, {
  immediate: true,
})


const beforeAvatarUpload: UploadProps['beforeUpload'] = (rawFile) => {
  // const isAudio = file.name.substring(file.name.length - 3) === 'mp3'
  if (rawFile.type !== 'audio/mpeg') {
    proxy.$msg.error('上传文件只能是Mp3格式！')
    return false
  }
  // else if (rawFile.size / 1024 / 1024 > 5) {
  //   proxy.$msg.error('上传文件大小不能超过 5MB！')
  //   return false
  // }
  return true
}

// 进度条

let timer = null
let finishtimer = null
const uploadProgress = () => {
  progressFlag.value = true
  if (!timer) {
    timer = window.setInterval(() => {
      if (progressValue.value < 66) {
        progressValue.value++
        if (progressValue.value >= 66) {
          window.clearInterval(timer)
          timer = null
        }
      }
    }, 500)
  }

}




//文件移除配置方法
const handleRemove = (file, files) => {
  window.clearInterval(timer)
  window.clearInterval(finishtimer)
  timer = null
  finishtimer = null
  progressValue.value = 0
  progressFlag.value = false
  fileList.value = [];
  emit('confirm', {})
}

// 文件上传成功时的钩子
const handleAvatarSuccess: UploadProps['onSuccess'] = (response, uploadFile) => {

  if (response && response.code == 0) {
    if (!finishtimer) {
      finishtimer = window.setInterval(() => {
        if (progressValue.value < 100) {
          progressValue.value++
          if (progressValue.value >= 100) {
            progressValue.value = 100
            window.clearInterval(finishtimer)
            finishtimer = null
            // progressFlag.value = false
            // 上传成功之后后台返回的数据
            if (response.data.length) {
              const { bucketId, fileName, originalFilename, size, } = response.data[0]
              let obj = {
                serverId: bucketId,
                fileName: originalFilename,
                fileSize: size,
                fileUrl: fileName,
              }
              emit('confirm', obj)
            }
          }
        }
      }, 80)
    }
  } else {
    progressValue.value = 0
    progressFlag.value = false
    // proxy.$msg.error(response.msg)
  }
}




return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_upload, {
      ref_key: "upload",
      ref: upload,
      "file-list": fileList.value,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
      class: "upload-demo",
      action: url.value + '/evaluate//file/oss-upload',
      headers: headers,
      limit: 1,
      accept: ".mp3",
      "on-success": handleAvatarSuccess,
      "on-remove": handleRemove,
      "on-progress": uploadProgress,
      "before-upload": beforeAvatarUpload
    }, {
      tip: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: progressFlag.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("上传")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["file-list", "action"]),
    (progressFlag.value)
      ? (_openBlock(), _createBlock(_component_el_progress, {
          key: 0,
          class: "el-progress-value",
          percentage: progressValue.value,
          striped: "",
          "striped-flow": "",
          duration: duration.value
        }, null, 8, ["percentage", "duration"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})